<!-- <div style="display: flex; justify-content: end; gap: 10px">
<button nz-button nzType="default" (click)="openGroup()">Open Group</button>
<button nz-button nzType="default" (click)="openGroupInParameterView()">
  Open Group in Parameter View
</button>
</div> -->
<nz-table
  class="styled-table job-group-table"
  #filterTable
  [nzData]="this.jobs"
  [nzLoading]="isLoading"
  [nzScroll]="{ y: '200px' }"
  nzSize="small"
  nzShowPagination
  nzShowSizeChanger
  >
  <thead>
    <tr>
      @for (column of this.listOfColumns; track column) {
        <th
          [nzSortOrder]="column.sortOrder"
          [nzSortFn]="column.sortFn"
          [nzSortDirections]="column.sortDirections"
          [nzFilterMultiple]="column.filterMultiple"
          >
          {{ column.name }}
        </th>
      }
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    @for (data of filterTable.data; track data) {
      <tr>
        <td>{{ data.job__job_name }}</td>
        <td>
          {{ data.job__comments }}
        </td>
        <td>
          <a
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to remove the job from this group?"
            (nzOnConfirm)="removeJobFromGroup(data)"
            nz-tooltip
            nzTooltipTitle="Remove job from group"
            >
            <span
              nz-icon
              nzType="delete"
              nzTheme="outline"
              style="font-size: larger"
            ></span>
          </a>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
